import React from 'react'
import i18n from 'i18next'

import Anchor from './Anchor'

import './styles/hoverInfo.scss'

function HoverInfo(props) {
    const {
        children, cssClass, title, desc, linkText, href, isExternal, target, dir,
    } = props

    return (
        <React.Fragment>
            <div className={`hover-info-container ${cssClass}`}>
                <div className="hover-info-target">
                    {children}
                </div>
                <div className={`hover-info-wrapper ${dir || ''}`}>
                    {title && <p className="hover-title">{title}</p>}
                    <p className="hover-desc" dangerouslySetInnerHTML={{ __html: desc }} />
                    {href && (
                        <div className="link-wrapper">
                            <Anchor
                                cssClass="read-link"
                                href={href}
                                target={target || '_blank'}
                                isExternal={isExternal || true}
                            >
                                {linkText || i18n.t('read_more', 'Read more')}
                                <i className="fa-sharp fa-regular fa-arrow-right" />
                            </Anchor>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}

export default HoverInfo
